import React from "react";
import PropTypes from "prop-types";
import SweetAlert from "react-bootstrap-sweetalert";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
// import Weekend from "@material-ui/icons/Weekend";
import Home from "@material-ui/icons/Home";
import Business from "@material-ui/icons/Business";
import AccountBalance from "@material-ui/icons/AccountBalance";

// core components
import GridContainer from "components/grid/GridContainer.js";
import GridItem from "components/grid/GridItem.js";
import Button from "components/custombuttons/Button.js";
import Card from "components/card/Card.js";
import CardHeader from "components/card/CardHeader.js";
import CardBody from "components/card/CardBody.js";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import yellowTape from "assets/img/yellow-tape-co-name.png"
import greenTape from "assets/img/green-tape-co-name-brand.png"
import whiteTape from "assets/img/white-tape-co-name-square.png"

import pricingPageStyle from "assets/jss/material-dashboard-pro-react/views/pricingPageStyle.jsx";
import { connect } from 'react-redux'
import { compose } from 'redux'



class AdministrationPage extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      alert: null
    };
  }
  

  showTapes(userID, templateID, numTapes) {
    console.log("Showing " + numTapes + " tapes.");
    this.hideAlert();
    if (numTapes !== null) {
        if(templateID === null) {
            window.alert('No Template provided');
            return;
        }

        var user = userID;
        var params = "user="+user+"&numTapes="+numTapes+"&templateID="+templateID+"&debug=true"+"&asPdf=true";
        var request = new Request('https://us-central1-multilanguage-dacbe.cloudfunctions.net/newTapes', {
	        headers: new Headers({
		        'Content-Type': 'application/x-www-form-urlencoded'
            }),
            method: 'POST',
            body: params
        });
        fetch(request).then(results => {
            let data = results.json();
            
            return data;
          })
          .then(data => {
              if (data.error !== undefined) {
                window.alert(data.error);
              } else {
                var pdfUrl = data.response;
                console.log(data);
                console.log(pdfUrl)
                
                window.open(pdfUrl, '_blank');
              }
          });
        }
  }

  genTapes(userID, templateID, numTapes) {
    this.setState({
        alert: (
          <SweetAlert
            input
            showCancel
            style={{width: "300px"}}
            title=""
            onConfirm={numTapes => this.showTapes(userID, templateID, numTapes)}
            onCancel={() => this.hideAlert()}
            //confirmBtnCssClass={
              //this.props.classes.button + " " + this.props.classes.success
            //}
            cancelBtnCssClass={
              this.props.classes.button + " " + this.props.classes.danger
            }
          >Number of tapes to print:</SweetAlert>
        )
      });
  }

  orderTapes(userID,templateID, numTapes) {
    this.setState({
        alert: (
          <SweetAlert
            input
            showCancel
            style={{ display: "block", marginTop: "-100px", width: "300px" }}
            
            onConfirm={numTapes => this.showTapes(userID, templateID, numTapes)}
            onCancel={() => this.hideAlert()}
            //confirmBtnCssClass={
              //this.props.classes.button + " " + this.props.classes.success
            //}
            cancelBtnCssClass={
              this.props.classes.button + " " + this.props.classes.danger
            }
          >Number of sheets to order:</SweetAlert>
        )
      });
  }

  hideAlert() {
      this.setState({alert: null});
  }

  render() {
    const { classes, auth } = this.props;
    
    return (
        
        <GridContainer>
          {this.state.alert}
            <GridItem xs={12} sm={12} md={4}>
        <Card plain className="center">
        <CardHeader color="primary">
                        <h6 className={classes.cardTitle}>Permanent Journal Tapes<br/> 1" x 2-5/8"</h6>
                        
        </CardHeader>
        <CardBody plain>
        
                <img class="card-img-top" src={yellowTape} alt="Card image cap"/>
               
              
              <p class="card-text" >Compatible with Avery® 5260, 8160, 5971.</p>
              <p class="card-text" >30 Tapes per Sheet</p>
              <button type="button" onClick={numTapes => this.genTapes(auth.uid,34254, numTapes)}>
              Self Print
              </button>
              <button type="button" onClick={numTapes => this.orderTapes(auth.uid,34254, numTapes)}>
              Let us Print for You
              </button>
                
            
        </CardBody>
        </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
        <Card plain className="center">
        <CardHeader color="primary">
                        <h6 className={classes.cardTitle}>Removable Journal Tapes<br/> 1" x 2-5/8"</h6>
                        
        </CardHeader>
        <CardBody plain>
        
                <img class="card-img-top"   src={greenTape} alt="Card image cap"/>
              
              <p class="card-text" >Compatible with Avery® 6460, 6479, 16460.</p>
              <p class="card-text" >30 Tapes per Sheet</p>
              <button type="button" onClick={numTapes => this.genTapes(auth.uid, 34254, numTapes)}>
              Self Print
              </button>
              <button type="button" onClick={numTapes => this.orderTapes(auth.uid,34254, numTapes)}>
              Let us Print for You
              </button>
            
        </CardBody>
        </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
        <Card plain className="center">
        <CardHeader color="primary">
                        <h6 className={classes.cardTitle}>Weatherproof Journal Tapes<br/> 2" x 2"</h6>
                        
        </CardHeader>
        <CardBody plain>
        
                <img class="card-img-top"  src={whiteTape} alt="Card image cap"/>
              
              <p class="card-text" >Compatible with Avery® 60526. Great for outdoor applications</p>
              <p class="card-text" >20 Tapes per Sheet</p>
              <button type="button" onClick={numTapes => this.genTapes(auth.uid,36295, numTapes)}>
              Self Print
              </button>
              <button type="button" onClick={numTapes => this.orderTapes(auth.uid,36295, numTapes)}>
              Let us Print for You
              </button>
            
        </CardBody>
        </Card>
        </GridItem>
      
      </GridContainer>
      
    );
  }
}

AdministrationPage.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = (state, ownProps) => {
  console.log(state);
  
  return {
    auth: state.firebase.auth
   
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(pricingPageStyle)
)(AdministrationPage)



// WEBPACK FOOTER //
// ./src/components/admin/AdministrationPage.js